import { FC } from "react";

// * Props
import TableProps from "./Table.interface";

// * Helpers
import cn from "classnames";

// * Styles
import styles from "./Table.module.css";

const Table: FC<TableProps> = ({
  headers,
  content,
  onRowClick,
  hoverMode = true,
  animationMode = false
}) => {
  return (
    <table className={styles["table"]}>
      <thead>
        <tr className={styles["table__row"]}>
          {headers && headers.map((header, index) => (
            <th
              key={index}
              className={styles["table__header"]}
            >
              <div className={styles["table__transcate"]}>
                {header}
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody className={cn(
        styles["table__body-container"]
      )}>
        {content && content.map(({ items, rowSpan, transcodePresetId, className, onClick, ...rowProps }) => (
          <tr
            key={transcodePresetId}
            className={cn(
              styles["table__row"],
              { [styles["table__row_hover"]]: hoverMode },
              { [styles["table__row_animate"]]: animationMode },
              className
            )}
            aria-rowspan={rowSpan}
            onClick={() => onRowClick?.(transcodePresetId)}
            {...rowProps}
          >
            {items.map(({ value, colSpan, onItemClick, containerClassName, className, ...dataParams }, index) => (
              <td
                key={index}
                className={cn(
                  styles["table__data"],
                  className
                )}
                colSpan={colSpan}
                onClick={() => onItemClick?.(transcodePresetId)}
                {...dataParams}
              >
                <div className={cn(
                  styles["table__transcate"],
                  styles["table__row-content"],
                  containerClassName
                )}>
                  {value}
                </div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;